import { html, ViewTemplate, when } from '@microsoft/fast-element';
import type { ProjectCard } from './project-card';
import { sync } from '@genesislcap/foundation-utils';
import { deleteIcon } from '../../../styles';
import { PROFILE_RIGHTS } from '../../../utils';

export const ProjectCardTemplate: ViewTemplate<ProjectCard> = html`
  <div
    class="project-card"
    style="border:${sync((x) => (x.isSelected ? '1px solid var(--primary-color)' : '1px'))}"
  >
    <div class="content">
      <div class="project-header-container">
        <p class="project-name project-underline')}">
          ${(x) => (x.project?.NAME ? x.project?.NAME : '- - -')}
        </p>

        ${when(
          (x) => x.userService.getFilteredPermissions().includes(PROFILE_RIGHTS.UPSERT_PROJECT),
          html<ProjectCard>`
            <p class="resume-setup" @click=${(x) => x.resumeDraftProject()}>Resume Setup</p>
          `
        )}
      </div>
      <div>
        <p class="project-company-name">${(x) => x.project?.CASCADE_COMPANY_NAME}</p>
      </div>
      <div class="project-info-container">
        <div class="info-section">
          <div>
            <p class="project-info-title">Type</p>
            <p class="project-info-value">${(x) => x.project?.TECHNOLOGY}</p>
          </div>
          <div>
            <p class="project-info-title">Capacity</p>
            <p class="project-info-value">
              ${(x) =>
                x.project?.AVAILABLE_CAPACITY_AC
                  ? x.project?.AVAILABLE_CAPACITY_AC + 'MW'
                  : '- - -'}
            </p>
          </div>
          <div>
            <p class="project-info-title">Location</p>
            <p class="project-info-value">
              ${(x) =>
                x.project?.COUNTRY_NAME === 'United States'
                  ? x.project?.STATE_NAME
                    ? x.project?.STATE_NAME
                    : '- - -'
                  : x.project?.COUNTRY_NAME}
            </p>
          </div>
        </div>
        ${when(
          (x) => x.userService.getFilteredPermissions().includes(PROFILE_RIGHTS.DELETE_PROJECT),
          html<ProjectCard>`
            <div class="delete-section">
              <div class="delete-icon" @click=${(x) => x.deleteDraftProject()}>
                ${deleteIcon('delete')}
              </div>
            </div>
          `
        )}
      </div>
    </div>
  </div>
`;
